<div class="sm:inset-0 flex flex-col flex-auto min-w-0 bg-card dark:bg-transparent">
    <div
        class="absolute inset-x-0 bottom-0"
        *ngIf="isLoading">
        <mat-progress-bar [mode]="'indeterminate'"></mat-progress-bar>
    </div>

    <!-- Header -->
    <div class="flex items-start md:items-center flex-col md:flex-row relative gap-6 p-6 sm:p-10 border-b bg-card dark:bg-transparent" style="background-color: #f1f5f9;">
      <!-- Title-->
        <div class="ml-2 lg:ml-0 text-3xl sm:text-4xl tracking-tight leading-none">Purchase Orders</div>

        <!-- Main actions -->
        <div class="flex flex-auto items-center gap-4 md:absolute md:right-[2.5rem] w-full md:w-max">
            <!-- Add PO button -->
            <button
                mat-flat-button
                [color]="'primary'"
                (click)="navigateToPurchaseOrderBuilder()"
                [disabled]="!allowedToCreatePOs">
                <mat-icon [svgIcon]="'heroicons_outline:plus'"></mat-icon>
                <span class="ml-2 mr-1">Add</span>
            </button>
        </div>

    </div>

    <!-- Main -->
    <div class="flex flex-auto">

        <!-- Purchase Orders list -->
        <div class="scrollable-list flex flex-col flex-auto">
            <ng-container *ngIf="purchaseOrders">
                <ng-container *ngIf="purchaseOrders.length > 0; else noPurchaseOrders">
                    <div class="grid">
                        <!-- Header -->
                        <div
                            class="z-10 sticky top-0 grid grid-cols-11 gap-4 py-4 px-6 md:px-8 shadow text-md  text-secondary bg-gray-50 dark:bg-black dark:bg-opacity-5"
                            matSort
                            matSortDisableClear>
                            <div
                                class="col-span-2 elipsis cursor-pointer flex" (click)="orderPOs('PurchaseOrderId')"
                                [mat-sort-header]="'purchaseOrderId'">
                                PO Number
                                <app-sort-chevrons [isSorting]="orderProperty == 'PurchaseOrderId'" [isAsc]="orderByAsc"/>
                            </div>
                            <div
                                class="col-span-3 elipsis cursor-pointer flex" (click)="orderPOs('Title')" 
                                [mat-sort-header]="'title'">
                                PO Title
                                <app-sort-chevrons [isSorting]="orderProperty == 'Title'" [isAsc]="orderByAsc"/>
                            </div>
                            <div
                                class="col-span-2 elipsis cursor-pointer flex" (click)="orderPOs('Date')" 
                                [mat-sort-header]="'date'">
                                Date
                                <app-sort-chevrons [isSorting]="orderProperty == 'Date'" [isAsc]="orderByAsc"/>
                            </div>
                            <div
                                class="col-span-2 elipsis cursor-pointer flex" (click)="orderPOs('Status')"
                                [mat-sort-header]="'status'">
                                Status
                                <app-sort-chevrons [isSorting]="orderProperty == 'Status'" [isAsc]="orderByAsc"/>
                            </div>
                            <div
                                class="col-span-2 elipsis cursor-pointer flex" (click)="orderPOs('Amount')"
                                [mat-sort-header]="'amount'">
                                Amount
                                <app-sort-chevrons [isSorting]="orderProperty == 'Amount'" [isAsc]="orderByAsc"/>
                            </div>
                        </div>
                        <!-- Rows -->
                        <ng-container *ngIf="purchaseOrders">
                            <ng-container *ngFor="let purchaseOrder of purchaseOrders; trackBy: trackByFn">
                                <div
                                    class="project-row grid grid-cols-11 gap-4 items-center py-3 px-6 md:px-8 border-b"
                                    (click)="navigateToPurchaseOrderBuilder(purchaseOrder.purchaseOrderId, $event)"
                                >
                                    <!-- purchaseOrderReference -->
                                    <div class="col-span-2 elipsis">
                                        {{purchaseOrder.salesOrderRef || ('NEX-ORD-' + (purchaseOrder.purchaseOrderId | number:'4.0').replace(',', '')) }}
                                    </div>

                                    <!-- customer -->
                                    <div class="col-span-3 elipsis">
                                        {{ purchaseOrder.title }}
                                    </div>

                                    <!-- purchaseOrderDate -->
                                    <div class="col-span-2 truncate elipsis">
                                        {{ purchaseOrder.date | date:'mediumDate' }}
                                    </div>

                                    <!-- Status -->
                                    <div class="col-span-2 elipsis text-center" [style]="getStatusStyle(purchaseOrder.status)">
                                        {{ getStatusText(purchaseOrder.status) }}
                                    </div>

                                    <!-- Amount -->
                                    <div class="col-span-2 elipsis">
                                        {{ purchaseOrder.amount | currency:'GBP':'symbol':'1.2-2' }}
                                    </div>
                                </div>
                            </ng-container>
                        </ng-container>
                    </div>

                    <mat-paginator
                        #paginator
                        class="mt-auto sm:inset-x-0 sm:bottom-0 border-b sm:border-t sm:border-b-0 z-10 bg-gray-50 bg-white"
                        [ngClass]="{'pointer-events-none': isLoading}"
                        [length]="pagination?.length"
                        [pageIndex]="pagination?.page"
                        [pageSize]="pagination?.size"
                        [pageSizeOptions]="[5, 10, 25, 100]"
                        [showFirstLastButtons]="true"></mat-paginator>

                </ng-container>
            </ng-container>
            <ng-template #noPurchaseOrders>
                <div *ngIf="searchTerm" class="p-8 sm:p-16 border-t text-4xl  tracking-tight text-center">
                    No purchase orders found!
                </div>
                <div *ngIf="!searchTerm" class="p-8 sm:p-16 border-t text-4xl  tracking-tight text-center">
                    There are no purchase orders!
                </div>
            </ng-template>
        </div>
    </div>
</div>
